import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latestComics = comics.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-500">最新章节第一时间送达</p>
          </div>
          <a
            href="/category/korean"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              tags={comic.tags}
              status={comic.status}
              updateInfo={comic.updateInfo}
              views={comic.views}
              rating={comic.rating}
              isNew={comic.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}